/*
 * @Author: your name
 * @Date: 2020-11-09 14:57:37
 * @LastEditTime: 2021-11-23 17:51:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ksh-factory-vue/src/services/downloadService.js
 */
import request from '@/utils/request'
import API from '@/apis/api-types'

export function getIndexDemandList (pageNo=1,pageSize=20){
  return request({
    method: 'post',
    url: API.getIndexDemandList,
    params: {pageNo, pageSize}
  })
}
